export const mutations = {
  NOTI_UPDATE_STATUS: "NOTI_UPDATE_STATUS",
  PINNED_SUCCESS: "PINNED_SUCCESS",
  UNPINNED_SUCCESS: "UNPINNED_SUCCESS",
  LOAD_MORE_NOTI: "LOAD_MORE_NOTI",
  TRACK_READ: "TRACK_READ",
  TRACK_ACTION: "TRACK_ACTION",
  MARK_ALL_READ: "MARK_ALL_READ"
};

export const actions = {
  SHOW_NOTIBAR: "showNotificationBar",
  CLOSE_NOTIBAR: "closeNotificationBar",
  TOOGLE_STICKY: "toogleSticky",
  TOOGLE_STICKY_FIRST_TIME: "toogleStickyFirstTime",
  DISMISS_STICKY_NOTI: "dismissStickyNoti",
  CLOSE_STICKY_MODAL: "closeSticky",
  SHOW_MODAL_NOTI: "showModalNoti",
  CLOSE_MODAL_NOTI: "closeModalNoti",
  OPEN_NOTI_CONTENT:"openNotiContent",
  CLOSE_NOTI_CONTENT:"closeNotiContent",
  LOAD_NOTI: "loadNoti",
  TRACK_ACTION: "trackAction",
  LOAD_MORE_NOTI: "loadMoreNoti",
  PIN_NOTI: "pinNoti",
  UNPIN_NOTI: "unpinNoti",
  PIN_NOTI_2: "pinNoti2",
  MARK_ALL_READ: "markAllAsRead"
};
